/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription 担保 =》 添加担保申请人表单组件入口js
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
import {columnsSFZ, columnsMZ, columnsGZDW, columnsRYLX, columnsSSDW, columnIsndate} from '@/utils/option.js';
import validate from '@/utils/validator/validator';
import {
    typeMz,
    typeSfzjlx,
    typeGzdwlx,
    typeZzlx
} from '@/filters/index';
import {
    PhoneRule,
    ZjhmRule,
    XmRule,
    mzRule,
    xbRule,
    NlRule,
    zjlxRule,
    TxdzRule,
    QymcRule,
    QyfrRule,
    GddhRule,
    zjyxqKsrqRule,
    zjyxqJsrqRule,
    nZzlxRule,
    CQyzzjgdmRule,
    dwxzRule,
    csrqRule
} from '@/utils/validator/rules';
import {dateFormat} from '@/utils/dateFormatter';
import {checkIdentify, getIDData, createId} from '@/utils/common';
import {mapGetters} from "vuex";

export default {
    name: 'app-guarantee-add-sqr',
    data() {
        return {
            // 申请人id
            sqrId:'',
            // 诉讼类型为1的表单数据
            formData_1: {},
            // 诉讼类型为2的表单数据
            formData_2: {},
            // 诉讼类型为3的表单数据
            formData_3: {},
            // 表单数据
            formData: {
                // 申请人id
                cId: '',
                // 申请人姓名
                cSqrxm: '',
                // 性别
                cSqrxb: '1',
                // 民族
                nMz: '1',
                // 民族文字描述
                nMzText: '汉族',
                //诉讼地位
                nSsdw: '2',
                //诉讼地位文字
                nSsdwText: '原申请人',
                // 年龄
                nNl: '',
                // 申请人出生日期,
                dtSqrBirthday: '',
                // 申请人出生日期文字描述
                dtSqrBirthdayText: '',
                // 证件类型
                cZjlx: '1',
                // 证件类型汉字描述
                cZjlxText: '居民身份证',
                // 证照类型，默认社会统一信用代码证
                nZzlx: 4,
                nZzlxText: '社会统一信用代码证',
                // 证件号码
                cZjh: '',
                // 固定电话
                cGh: '',
                // 手机号码
                cPhoneno: '',
                // 经常居住地
                cTxdz: '',
                // 单位名称
                cQymc: '',
                // 统一社会信用代码
                cQyzzjgdm: '',
                // 单位性质
                cDwxz: '',
                // 单位性质文字描述
                cDwxzText: '',
                // 企业法人
                cQyfr: '',
                // 申请人类型
                cSqrlx: '1',
                // 申请人类型文本
                cSqrlxText: '自然人',
                // 申请人证件有效期开始日期
                dtZjyxqKsrq: '',
                // 申请人证件有效期开始日期文字描述
                dtZjyxqKsrqText: '',
                // 申请人证件有效期结束日期
                dtZjyxqJsrq: '',
                // 申请人证件有效期结束日期文字描述
                dtZjyxqJsrqText: '',
                // 是否长期有效
                longTerm: false
            },
            // 申请人类型
            cSqrlx: '1',
            // 申请人类型描述
            cSqrlxText: '自然人',
            // 申请人类型
            showSqrlx: false,
            columnsSFZ: columnsSFZ,
            columnsMZ: columnsMZ,
            columnsGZDW: columnsGZDW,
            columnsRYLX: columnsRYLX,
            columnsSSDW:columnsSSDW,
            showZJLXPicker: false,
            showDatePicker: false,
            currentDate: new Date(),
            showMZPicker: false,
            showGZDWPicker: false,
            minDate: new Date("1800-01-01"),
            maxDate: new Date(),
            // 保存按钮是否可以点击
            saveBtnClickable: true,
            // 有效期列表
            columnsIndate: Object.freeze(columnIsndate),
            // 显示证件有效期列表
            showIndate: false,
            // 证件有效期开始日期
            showZjyxqKsrqDatePicker: false,
            zjyxqKsrqCurrentDate: new Date(),
            // 证件有效期结束日期
            showZjyxqJsrqDatePicker: false,
            zjyxqJsrqCurrentDate: new Date(),
            // 是否显示证照类型弹层
            showZZPicker: false
        }
    },
    props: {
        // 表单数据
        data: Object
    },
    computed: {
        // 证件类型
        ...mapGetters(['codeList_109000'])
    },
    components: {
        acLayoutForm
    },
    methods: {

        /**
         * 初始化代码值
         * @returns {void}
         * */
        initCodeType() {
            // 证件类型
            this.$store.dispatch('GetCodeType', 109000);
        },

        /**
         * 重置数据
         * @returns {void}
         * */
        resetData() {
            // 申请人id
            this.sqrId = '';
            // 诉讼类型为1的表单数据
            this.formData_1 = {};
            // 诉讼类型为2的表单数据
            this.formData_2 = {};
            // 诉讼类型为3的表单数据
            this.formData_3 = {};
            // 表单数据
            this.formData = {
                // 申请人id
                cId: '',
                // 申请人姓名
                cSqrxm: '',
                // 性别
                cSqrxb: '1',
                // 民族
                nMz: '1',
                // 民族文字描述
                nMzText: '汉族',
                //诉讼地位
                nSsdw: '2',
                //诉讼地位文字
                nSsdwText: '原申请人',
                // 年龄
                nNl: '',
                // 申请人出生日期,
                dtSqrBirthday: '',
                // 申请人出生日期文字描述
                dtSqrBirthdayText: '',
                // 证件类型
                cZjlx: '1',
                // 证件类型汉字描述
                cZjlxText: '居民身份证',
                // 证照类型，默认社会统一信用代码证
                nZzlx: 4,
                nZzlxText: '社会统一信用代码证',
                // 证件号码
                cZjh: '',
                // 固定电话
                cGh: '',
                // 手机号码
                cPhoneno: '',
                // 经常居住地
                cTxdz: '',
                // 单位名称
                cQymc: '',
                // 统一社会信用代码
                cQyzzjgdm: '',
                // 单位性质
                cDwxz: '',
                // 单位性质文字描述
                cDwxzText: '',
                // 企业法人
                cQyfr: '',
                // 申请人类型
                cSqrlx: '1',
                // 申请人类型文本
                cSqrlxText: '自然人',
                // 申请人证件有效期开始日期
                dtZjyxqKsrq: '',
                // 申请人证件有效期开始日期文字描述
                dtZjyxqKsrqText: '',
                // 申请人证件有效期结束日期
                dtZjyxqJsrq: '',
                // 申请人证件有效期结束日期文字描述
                dtZjyxqJsrqText: '',
                // 是否长期有效
                longTerm: false
            };
            // 申请人类型
            this.cSqrlx = 1;
            // 申请人类型描述
            this.cSqrlxText = '自然人';
        },
        /**
         * 选择了申请人类型
         * @param {Object} item 申请人信息项数据
         * @returns {void}
         * */
        onSelectSqrlx(item) {
            // 隐藏申请类型选择面板
            this.showSqrlx = false;
            // 如果申请人类型不变，则直接返回
            if (item.keyId === this.cSqrlx) {
                return;
            }
            // 申请人类型赋值
            this.cSqrlx = item.keyId;
            // 申请人类型文本赋值
            this.cSqrlxText = item.text;

            // 下面操作，主要是为了点击确认之后，在列表页面不用再转化赋值
            // 申请人类型
            this[`formData_${this.cSqrlx}`].cSqrlx = item.keyId;
            // 申请人类型文本赋值
            this[`formData_${this.cSqrlx}`].cSqrlxText = item.text;
        },

        /**
         * 选择证件类型
         * @param {Object} item 证件类型信息项数据
         * @returns {void}
         * */
        onZJLXConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].cZjlx = item.keyId;
            this[`formData_${this.cSqrlx}`].cZjlxText = item.text;
            this.showZJLXPicker = false;
        },

        /**
         * 证件有效期开始日期确认时间
         * */
        onZjyxqKsrqDatePickerConfirm: function () {
            this.zjyxqKsrqCurrentDate = new Date(this.zjyxqKsrqCurrentDate.setHours(8));
            // this[`formData_${this.cSqrlx}`].dtZjyxqKsrq = this.zjyxqKsrqCurrentDate;
            this.showZjyxqKsrqDatePicker = false;
            this[`formData_${this.cSqrlx}`].dtZjyxqKsrq = dateFormat(this.zjyxqKsrqCurrentDate, "yyyy-MM-dd");
            // 如果结束日期小于开始日期，则将结束日期设置成开始日期
            if (this.zjyxqJsrqCurrentDate && this.zjyxqJsrqCurrentDate.getTime() < this.zjyxqKsrqCurrentDate.getTime()) {
                this.zjyxqJsrqCurrentDate = this.zjyxqKsrqCurrentDate;
                // 触发证件有效期结束日期选择
                this.onZjyxqJsrqDatePickerConfirm();
            }
        },
        /**
         * 证件有效期结束日期确认时间
         * */
        onZjyxqJsrqDatePickerConfirm: function () {
            this.zjyxqJsrqCurrentDate = new Date(this.zjyxqJsrqCurrentDate.setHours(8));
            // this[`formData_${this.cSqrlx}`].dtZjyxqJsrq = this.zjyxqJsrqCurrentDate;
            this.showZjyxqJsrqDatePicker = false;
            this[`formData_${this.cSqrlx}`].dtZjyxqJsrq = dateFormat(this.zjyxqJsrqCurrentDate, "yyyy-MM-dd");
            // 如果开始日期大于结束日期，则将开始日期设置成结束日期
            if (this.zjyxqKsrqCurrentDate && this.zjyxqKsrqCurrentDate.getTime() > this.zjyxqJsrqCurrentDate.getTime()) {
                this.zjyxqKsrqCurrentDate = this.zjyxqJsrqCurrentDate;
                // 触发证件有效期开始日期选择
                this.onZjyxqKsrqDatePickerConfirm();
            }
        },
        /**
         * 有效期列表确认
         * @returns {void}
         * */
        onIndateConfirm(item) {
            // 长期有效
            if (item.keyId === 1) {
                // 有效期结束日期为长期
                this[`formData_${this.cSqrlx}`].dtZjyxqJsrq = '长期';
                // 显示文本为长期
                this[`formData_${this.cSqrlx}`].dtZjyxqJsrqText = '长期有效';
                // 证件有效期结束时间置空
                this.zjyxqJsrqCurrentDate = '';
            } else {
                // 选择有效期至，则显示结束日期控件
                this.showZjyxqJsrqDatePicker = true;
            }
            // 隐藏有效期列表弹层
            this.showIndate = false;
        },

        /**
         * 选择出生日期
         * @returns {void}
         * */
        onDatePickerConfirm: function () {
            this.currentDate = new Date(this.currentDate.setHours(8));
            this[`formData_${this.cSqrlx}`].dtSqrBirthday = dateFormat(this.currentDate, "yyyy-MM-dd");
            this.showDatePicker = false;
        },

        /**
         * 解析身份证号
         * @returns {void}
         * */
        identifyAnalyzer: function () {
            // 如果证件类型不为1 身份证号，则直接返回
            if (this[`formData_${this.cSqrlx}`].cZjlx != 1) {
                return;
            }
            // 证件号码
            let zjhm = this[`formData_${this.cSqrlx}`].cZjh;
            // 校验证件号码是否正确
            let correct = checkIdentify(zjhm);
            if (correct) {
                // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
                getIDData(zjhm).then(res => {
                    let data = res.data;
                    this[`formData_${this.cSqrlx}`] = {
                        ...this[`formData_${this.cSqrlx}`],
                        ...{
                            dtSqrBirthday: data.cBirthdate,
                            nNl: data.nAge,
                            cSqrxb: data.cSex
                        }
                    };
                });
            }
        },

        /**
         * 选择民族
         * @param {Object} item 民族信息项数据
         * @returns {void}
         * */
        onMZConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].nMz = item.keyId;
            this[`formData_${this.cSqrlx}`].nMzText = item.text;
            this.showMZPicker = false;
        },

        /**
         * 选择证照类型
         * @param {Object} item 证照类型信息项数据
         * @returns {void}
         * */
        onZZConfirm: function(item){
            this[`formData_${this.cSqrlx}`].nZzlx = item.keyId;
            this[`formData_${this.cSqrlx}`].nZzlxText = item.text;
            this.showZZPicker = false;
        },

        /**
         * 选择单位性质
         * @param {Object} item 单位性质信息项数据
         * @returns {void}
         * */
        onGZDWConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].cDwxz = item.keyId;
            this[`formData_${this.cSqrlx}`].cDwxzText = item.text;
            this.showGZDWPicker = false;
        },

        /**
         * 获取参数
         * */
        getParams() {
            return this[`formData_${this.cSqrlx}`];
        },

        /**
         * 返回事件
         * @returns {void}
         * */
        back() {
            this.$emit('cancel');
        },

        /**
         * 刷新操作
         * @returns {void}
         * */
        refresh() {
            // 重置数据
            this.resetData();
            // 重新走初始化流程
            this.init();
            // 返回顶部
            this.$refs.con && this.$refs.con.goToTop();
        },

        /**
         * 添加/确认按钮点击事件
         * @returns {void}
         * */
        addSqrAndReturn: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认事件
                this.$emit('confirm', this[`formData_${this.cSqrlx}`]);
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 确认并添加按钮点击事件
         * @returns {void}
         * */
        addSqrAndContinue: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认并继续事件
                this.$emit('confirm-continue', this[`formData_${this.cSqrlx}`]);
                // 刷新当前表单
                this.refresh();
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 申请类型为1 自然人的表单验证
         * @returns {Promise}
         * */
        validateFormData_1: function() {
            // 自然人校验规则
            let descriptor = {
                // 姓名
                cSqrxm: new XmRule(true),
                // 证件类型
                cZjlx: zjlxRule
            };
            // 身份证的时候需要校验证件有效期开始日期
            if (this.formData_1.cZjlx === '1') {
                descriptor = {
                    ...descriptor,
                    // 证件有效期开始日期
                    dtZjyxqKsrq: zjyxqKsrqRule,
                    // 证件有效期结束日期
                    dtZjyxqJsrq: zjyxqJsrqRule,
                }
            }
            descriptor = {
                ...descriptor,
                // 证件号码
                cZjh: new ZjhmRule(this.formData_1.cZjlx, true),
                // 出生日期非必填
                dtSqrBirthday: csrqRule,
                // 年龄
                nNl: new NlRule(true),
                // 性别
                cSqrxb: xbRule,
                // 民族
                nMz: mzRule,
                // 手机号码
                cPhoneno: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 经常居住地
                cTxdz: new TxdzRule(this.cSqrlx, true)
            }
            let validated = validate(descriptor, this.formData_1);
            return validated;
        },

        /**
         * 申请类型为 2 法人的表单验证
         * @returns {Promise}
         * */
        validateFormData_2: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                // 证照类型
                nZzlx: nZzlxRule,
                // 证照号码
                cQyzzjgdm: new CQyzzjgdmRule(Number(this.formData_2.nZzlx),true),
                // 单位性质
                cDwxz: dwxzRule,
                // 法定代表人
                cQyfr: new QyfrRule(this.cSqrlx, true),
                // 手机号码
                cPhoneno: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cSqrlx, true)
            };
            let validated = validate(descriptor, this.formData_2);
            return validated;
        },

        /**
         * 申请类型为 3 非法人组织的表单验证
         * @returns {Promise}
         * */
        validateFormData_3: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                // 证照类型
                nZzlx: nZzlxRule,
                // 证照号码
                cQyzzjgdm: new CQyzzjgdmRule(Number(this.formData_2.nZzlx),true),
                // 单位性质
                cDwxz: dwxzRule,
                // 法定代表人
                cQyfr: new QyfrRule(this.cSqrlx, true),
                // 手机号码
                cPhoneno: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cSqrlx, true)
            };
            let validated = validate(descriptor, this.formData_3);
            return validated;
        },

        /**
         * 验证表单数据
         * @returns {Promise}
         * */
        validateFormData: function () {
            return new Promise((resolve, reject) => {
                // 对应的验证规则
                const validated = this[`validateFormData_${this.cSqrlx}`]();
                validated.then(() => {
                   // 校验通过
                   resolve();
                }).catch(() => {
                    console.log('请完整填写表单数据');
                    reject();
                });
            });
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 如果数据存在
            if (this.data) {
                // 表单数据赋值默认的表单数据
                this.formData_1 = {
                    ...this.formData
                };
                this.formData_2 = {
                    ...this.formData
                };
                this.formData_3 = {
                    ...this.formData
                };
                // 数据进行赋值
                const _formData = {
                    ...this.data
                };
                // 民族需要转化成文本
                _formData.nMzText = typeMz(_formData.nMz);
                // 证件类型
                _formData.cZjlxText = typeSfzjlx(_formData.cZjlx);
                // 单位性质
                _formData.cDwxzText = typeGzdwlx(_formData.cDwxz);
                // 证照类型
                _formData.nZzlxText = typeZzlx(_formData.nZzlx);
                // 证件有效期开始日期
                _formData.dtZjyxqKsrqText = _formData.dtZjyxqKsrq;
                // 证件有效期结束日期
                _formData.dtZjyxqJsrqText = _formData.dtZjyxqJsrq;
                // 申请人id赋值
                this.sqrId = _formData.cId;
                // 申请人类型
                this.cSqrlx = _formData.cSqrlx;
                // 申请人类型文本
                this.cSqrlxText = _formData.cSqrlxText;
                // 表单id赋值
                this.formData_1.cId = _formData.cId;
                // 表单id赋值
                this.formData_2.cId = _formData.cId;
                // 表单id赋值
                this.formData_3.cId = _formData.cId;
                // 表单赋值
                this[`formData_${_formData.cSqrlx}`] = _formData;
            } else {
                // 创建id
                createId().then(id => {
                    this.formData.cId = id;
                    // 设置是属于新增
                    this.formData.isAdd = true;
                    // 表单数据赋值默认的表单数据
                    this.formData_1 = {
                        ...this.formData
                    };
                    this.formData_2 = {
                        ...this.formData
                    };
                    this.formData_3 = {
                        ...this.formData
                    };
                });
            }
        }
    },
    created() {
        // 初始化代码值
        this.initCodeType();
        // 初始化方法
        this.init();
    }
}
